import { Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  panel: {
    padding: theme.spacing(6),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }
}))

// Maps the last path segment of /apartments/<section> to a readable title.
const SECTION_TITLES = {
  enrolments: 'Enrolments',
  attendance: 'Attendance',
  trials: 'Trials',
  inventory: 'Inventory',
  issues: 'Issues & Notes',
  payout: 'Apartment Payout',
  pricing: 'Pricing'
}

const ApartmentComingSoon = () => {
  const classes = useStyles()
  const { pathname } = useLocation()
  const segment = pathname.split('/').filter(Boolean).pop()
  const title = SECTION_TITLES[segment] || 'This section'

  return (
    <div className={classes.root}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Paper variant="outlined" className={classes.panel}>
        <Typography variant="h6">{title} — coming in a later slice</Typography>
        <Typography variant="body2">
          Building the apartment module frontend-first against mocked data.
          Dashboard and Payments are live; this section is next.
        </Typography>
      </Paper>
    </div>
  )
}

export default ApartmentComingSoon
